import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-code-code-page.header.title',
		defaultMessage: 'Code',
		description:
			'This is the page title for code page. Code page is the page where users connect Jira to their software source "code" management system. The page is intended to show consolidated information about the connected software source "code" management system. In many(not all) languages, this word is not translated, but literally called "Code" in each language format.',
	},
});
